import { render, staticRenderFns } from "./IEdit.vue?vue&type=template&id=5102019e&"
import script from "./IEdit.vue?vue&type=script&lang=ts&"
export * from "./IEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports